var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"org-tree-container"},[_c('el-tree',{ref:"orgTree",staticStyle:{"width":"100%"},attrs:{"data":_vm.orgTreeShowInfo.orgs,"props":_vm.defaultProps,"node-key":"id","default-expand-all":"","highlight-current":""},on:{"node-click":_vm.handleNodeClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }